import type { UnifiedMarketItem } from "@shared/schema";

export function hasMarketImage(
  item: Pick<UnifiedMarketItem, "id" | "images">,
  failedImageIds: ReadonlySet<string> = new Set(),
) {
  if (failedImageIds.has(String(item.id))) return false;
  return Boolean(item.images?.some((url) => typeof url === "string" && url.trim().length > 0));
}

export function sortMarketItemsPhotoFirst(
  items: UnifiedMarketItem[],
  failedImageIds: ReadonlySet<string> = new Set(),
) {
  return [...items].sort((a, b) => {
    const imageDifference = Number(hasMarketImage(b, failedImageIds)) - Number(hasMarketImage(a, failedImageIds));
    if (imageDifference !== 0) return imageDifference;

    const bTime = new Date(b.createdAt).getTime() || 0;
    const aTime = new Date(a.createdAt).getTime() || 0;
    return bTime - aTime;
  });
}
